import React, { useState,useEffect } from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import { BASE_URL } from '../Config/Base'
import { ToastContainer,toast } from 'react-toastify'
import _ from 'lodash'
// import cause from '../Assets/Images/causeParo.png'
import index from '../Assets/Images/indeximg.jpg'
// import Pay from '../Assets/Images/Payementimg.jpg'
import Top from '../Assets/Images/TopgifParo.gif'
import Slider from '../Assets/Images/SlidergifParo.gif'
import bottom from '../Assets/Images/bottomgifParo.gif'



const ParoIndexMain = () => {
  return (
    <div className='Paro-addmain'>

    {/*  Toastify */ }

   
<div className="Paro-addgrid-layout">
   <div className="Paro-addmain-top">
       <div className='Paro-addmain-back'>
          <Link to='/ParoSection'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
       </div> 
          <span>Index</span>


    </div>
</div>

<section class="card-area">


<section class="card-section">
   <div class="card" id="Parocard">
       <div class="flip-card">
           <div class="flip-card__container">
               <div class="card-front">
                   <div class="card-front__tp card-front__tp--Top">
                       {/* <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve" class="card-front__icon">
                  <g>
                      <path d="M49.7,22c-1.1,0-2,0.9-2,2v32.2c0,1.1,0.9,2,2,2s2-0.9,2-2V24C51.7,22.9,50.8,22,49.7,22z"/>
                      <path d="M13,29.5c1.1,0,2-0.9,2-2s-0.9-2-2-2H5.7v-3h20.8c1.1,0,2-0.9,2-2s-0.9-2-2-2H5.7v-3h20.8c1.1,0,2-0.9,2-2s-0.9-2-2-2H5.7
                          V7.1h24.8v15.3c0,1.1,0.9,2,2,2s2-0.9,2-2V5.1c0-1.1-0.9-2-2-2H3.7c-1.1,0-2,0.9-2,2v51c0,1.1,0.9,2,2,2s2-0.9,2-2V36.5H13
                          c1.1,0,2-0.9,2-2s-0.9-2-2-2H5.7v-3H13z"/>
                      <path d="M58,11.9c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1-0.1-0.2c0-0.1,0-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0
                          c0-0.1-0.1-0.1-0.1-0.2c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1c0,0-0.1-0.1-0.2-0.1
                          c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.1,0-0.2-0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2,0c0,0,0,0,0,0
                          c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1c0,0-0.1,0-0.1,0.1l-12.6,7.8
                          c0,0,0,0,0,0c-0.1,0-0.1,0.1-0.2,0.1c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2
                          c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1-0.1,0.2c0,0.1,0,0.1-0.1,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0v5.4H22.1
                          c-1.1,0-2,0.9-2,2v28.9c0,1.1,0.9,2,2,2s2-0.9,2-2V29.3h17.3v26.9c0,1.1,0.9,2,2,2s2-0.9,2-2V21l8.6-5.3v40.5c0,1.1,0.9,2,2,2
                          s2-0.9,2-2V12.1C58,12,58,12,58,11.9z"/>
                      <path d="M28,31L28,31c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S29.1,31,28,31z"/>
                      <path d="M33.5,31L33.5,31c-1.1,0-2,0.9-2,2s0.9,2,2,2c1.1,0,2-0.9,2-2S34.6,31,33.5,31z"/>
                      <path d="M28,36L28,36c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S29.1,36,28,36z"/>
                      <path d="M33.5,36L33.5,36c-1.1,0-2,0.9-2,2s0.9,2,2,2c1.1,0,2-0.9,2-2S34.6,36,33.5,36z"/>
                  </g>
                  </svg> */}

                  {/* <h2 class="card-front__heading">
                   Top Section
               </h2> */}
               {/* <p class="card-front__text-price">
                   From £29
               </p> */}
                   </div>

                   <div class="card-front__bt">
                       <p class="card-front__text-view card-front__text-view--city" id="ParoSlidertext">
                       What we do
                       </p>
                   </div>
               </div>
               <div class="card-back">

                 <img src={Top} class="video__container"></img>
                   {/* <video class="video__container" autoplay muted loop>
                       <source class="video__media" src="https://player.vimeo.com/external/370331493.sd.mp4?s=e90dcaba73c19e0e36f03406b47bbd6992dd6c1c&profile_id=139&oauth2_token_id=57447761" type="video/mp4">
                   </video> */}
               </div>
           </div>
       </div>

       <div class="inside-page">
           <div class="inside-page__container"><br></br>
               {/* <h3 class="inside-page__heading inside-page__heading--city">
                   For urban lovers
               </h3> */}
               {/* <p class="inside-page__text">
               Food Packets Required!
               </p> */}

               <img src={index} id="causeimg"></img>
               <Link to ="/ParoSectionIndexTop"  class="inside-page__btn inside-page__btn--city">Click here</Link>
           </div>
       </div>
   </div>
</section>


<section class="card-section">
   <div class="card" id="Parocard">
       <div class="flip-card">
           <div class="flip-card__container">
               <div class="card-front">
                   <div class="card-front__tp card-front__tp--slide">
                       {/* <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve" class="card-front__icon">
                  <g>
                      <path d="M58.8,54.5L38.5,19.3c-0.4-0.6-1-1-1.7-1s-1.4,0.4-1.7,1L14.8,54.5c-0.4,0.6-0.4,1.4,0,2c0.4,0.6,1,1,1.7,1h40.6
                          c0.7,0,1.4-0.4,1.7-1C59.2,55.9,59.2,55.1,58.8,54.5z M36.8,24.3l5.8,10c-0.5-0.2-1.1-0.3-1.7-0.3c-2.5,0-3.7,1.5-4.6,2.5
                          c-0.7,0.9-1,1.1-1.5,1.1s-0.8-0.2-1.5-1.1c-0.6-0.7-1.3-1.5-2.4-2.1L36.8,24.3z M20,53.5l8.9-15.4c0.5,0,0.7,0.3,1.4,1.1
                          c0.8,1,2.1,2.5,4.6,2.5s3.7-1.5,4.6-2.5c0.7-0.9,1-1.1,1.5-1.1c0.5,0,0.8,0.2,1.5,1.1c0.8,1,2.1,2.5,4.5,2.5l6.8,11.8H20z"/>
                      <path d="M14.7,51.5c1.1,0,2-0.9,2-2s-0.9-2-2-2H6.4l9.1-15.7c0.6,0.6,1.5,1.3,2.9,1.3c1.8,0,2.8-1.2,3.3-1.8
                          c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0.1,0.2,0.2,0.3,0.3c0.5,0.6,1.5,1.8,3.3,1.8c1.1,0,2-0.9,2-2c0-1.1-0.9-2-1.9-2
                          c-0.1-0.1-0.2-0.2-0.3-0.4c-0.5-0.6-1.5-1.8-3.3-1.8c-1.8,0-2.8,1.2-3.3,1.8c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1-0.1-0.2-0.2-0.3-0.3
                          c-0.1-0.2-0.3-0.4-0.5-0.6l5.7-9.9l3.8,6.6c0.6,1,1.8,1.3,2.7,0.7c1-0.6,1.3-1.8,0.7-2.7L25,13.2c-0.4-0.6-1-1-1.7-1
                          s-1.4,0.4-1.7,1l-8.4,14.5c-0.1,0.1-0.2,0.3-0.3,0.4L1.2,48.5c0,0,0,0.1,0,0.1c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1-0.1,0.2
                          c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2C1,50,1,50,1,50.1
                          c0,0.1,0,0.1,0.1,0.2c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.1,0.1,0.2c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1
                          c0.1,0,0.1,0.1,0.2,0.1c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0.1,0.2,0.1,0.3,0.1c0,0,0.1,0,0.1,0c0.1,0,0.3,0.1,0.5,0.1c0,0,0,0,0,0
                          c0,0,0,0,0,0c0,0,0,0,0,0H14.7z"/>
                      <path d="M40.7,12.3h3.1l-2.2,2.2c-0.6,0.6-0.6,1.5,0,2.1c0.3,0.3,0.7,0.4,1.1,0.4s0.8-0.1,1.1-0.4l2.2-2.2v3.1
                          c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5v-3.1l2.2,2.2c0.3,0.3,0.7,0.4,1.1,0.4s0.8-0.1,1.1-0.4c0.6-0.6,0.6-1.5,0-2.1l-2.2-2.2h3.1
                          c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5h-3.1l2.2-2.2c0.6-0.6,0.6-1.5,0-2.1c-0.6-0.6-1.5-0.6-2.1,0L49,7.2V4
                          c0-0.8-0.7-1.5-1.5-1.5S46,3.2,46,4v3.1l-2.2-2.2c-0.6-0.6-1.5-0.6-2.1,0c-0.6,0.6-0.6,1.5,0,2.1l2.2,2.2h-3.1
                          c-0.8,0-1.5,0.7-1.5,1.5S39.9,12.3,40.7,12.3z"/>
                  </g>
                  </svg> */}
                                  {/* <h2 class="card-front__heading">
                                      Slider Section
                                  </h2> */}
                                  {/* <p class="card-front__text-price">
                                      From £199
                                  </p> */}
                   </div>

                   <div class="card-front__bt">
                       <p class="card-front__text-view card-front__text-view--ski" id="ParoSlidertext">
                       Opportunity to bring a Smile
                       </p>
                   </div>
               </div>

               <div class="card-back">
               <img src={Slider} class="video__container"></img>
                   {/* <video class="video__container" autoplay muted loop>
                       <source class="video__media" src="https://player.vimeo.com/external/195913085.sd.mp4?s=7c12f7a83de62a8900fd2ae049297070b9bc8a54&profile_id=164&oauth2_token_id=574477611" type="video/mp4">
                   </video> */}
               </div>
           </div>
       </div>

       <div class="inside-page">
           <div class="inside-page__container">
             <br></br>
               {/* <h3 class="inside-page__heading inside-page__heading--ski">
                   For snow lovers
               </h3> */}
               {/* <p class="inside-page__text">
                  Love snow? Why not take up exciting ski-in sessions and hit the slope? 
               </p> */}

               <img src={index} id="causeimg"></img>
               <Link to="/ParoIndexSlider" class="inside-page__btn inside-page__btn--ski">Click here</Link>
           </div>
       </div>
   </div>
</section>


<section class="card-section">
   <div class="card" id="Parocard">
       <div class="flip-card">
           <div class="flip-card__container">
               <div class="card-front">
                   <div class="card-front__tp card-front__tp--bot">
                       {/* <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve" class="card-front__icon">
                  <path d="M57.2,28h-7.4c-0.4-4-2-7.7-4.4-10.6l3.2-3.2c0.8-0.8,0.8-2,0-2.8c-0.8-0.8-2-0.8-2.8,0l-3.2,3.2c-3-2.4-6.6-4-10.6-4.4V2.8
                      c0-1.1-0.9-2-2-2s-2,0.9-2,2v7.4c-4,0.4-7.7,2-10.6,4.4l-3.2-3.2c-0.8-0.8-2-0.8-2.8,0c-0.8,0.8-0.8,2,0,2.8l3.2,3.2
                      c-2.4,3-4,6.6-4.4,10.6H2.8c-1.1,0-2,0.9-2,2s0.9,2,2,2h7.4c0.4,4,2,7.7,4.4,10.6l-3.2,3.2c-0.8,0.8-0.8,2,0,2.8
                      c0.4,0.4,0.9,0.6,1.4,0.6s1-0.2,1.4-0.6l3.2-3.2c3,2.4,6.6,4,10.6,4.4v7.4c0,1.1,0.9,2,2,2s2-0.9,2-2v-7.4c4-0.4,7.7-2,10.6-4.4
                      l3.2,3.2c0.4,0.4,0.9,0.6,1.4,0.6s1-0.2,1.4-0.6c0.8-0.8,0.8-2,0-2.8l-3.2-3.2c2.4-3,4-6.6,4.4-10.6h7.4c1.1,0,2-0.9,2-2
                      S58.3,28,57.2,28z M30,45.9c-8.8,0-15.9-7.2-15.9-15.9c0-8.8,7.2-15.9,15.9-15.9c8.8,0,15.9,7.2,15.9,15.9
                      C45.9,38.8,38.8,45.9,30,45.9z"/>
                  </svg> */}
{/*                   
                                  <h2 class="card-front__heading">
                                     Bottom Section
                                  </h2> */}
                                  {/* <p class="card-front__text-price">
                                      From £229
                                  </p> */}
                   </div>

                   <div class="card-front__bt">
                       <p class="card-front__text-view card-front__text-view--beach" id="ParoSlidertext">
                       Footer
                       </p>
                   </div>
               </div>
               <div class="card-back">
               <img src={bottom} class="video__container"></img>
                   {/* <video class="video__container" autoplay muted loop>
                       <source class="video__media" src="https://player.vimeo.com/external/332588783.sd.mp4?s=cab1817146dd72daa6346a1583cc1ec4d9e677c7&profile_id=139&oauth2_token_id=57447761" type="video/mp4">
                   </video> */}
               </div>
           </div>
       </div>

       <div class="inside-page">
           <div class="inside-page__container">

             <br></br>
               {/* <h3 class="inside-page__heading inside-page__heading--beach">
                   For sun lovers
               </h3>
               <p class="inside-page__text">
                  Relax and get sun-kissed tan in the sea or take up surfting for an adventure!
               </p> */}

               <img src={index} id="causeimg"></img>
               <Link to="/ParoIndexbottom" class="inside-page__btn inside-page__btn--beach">Click here</Link>
           </div>
       </div>
   </div>
</section>


</section>
</div>
  )
}

export default ParoIndexMain